import type { QueryMeta } from '@unifyapps/network/utils/fetch/types';

export function getBasePath(queryMeta: QueryMeta): string {
  if (typeof window === 'undefined') {
    return '';
  }
  return (
    //   eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- just to make sure that the value is not undefined
    queryMeta?.apiDomain ??
    (window as { __unifyBaseUrl?: string }).__unifyBaseUrl ??
    window.location.origin
  );
}
